/* Interactive Liquid editor demo for the Super Tags marketing page.
   A faithful browser port of the app's own Liquid subset engine
   (super-tags-app/app/lib/liquid.ts) + highlighter (liquidHighlight.ts):
   lint (balanced tags, known tags, has add_tag), evaluate add_tag/remove_tag
   against six demo products with variants, and render the result live.
   Kept in the same order as the source files so the two stay easy to diff. */
(function () {
  var root = document.querySelector('[data-st-lq]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = '1';

  // ---- demo data -----------------------------------------------------------
  var PRODUCTS = [
    {
      title: 'Summit Zip Hoodie', type: 'Hoodies', vendor: 'Northwind Apparel',
      price: 79, compare_at_price: 99, total_inventory: 17, status: 'active', tags: ['hoodies'],
      variants: [
        { title: 'S / Slate', option1: 'S', option2: 'Slate', inventory_quantity: 6, price: 79 },
        { title: 'M / Slate', option1: 'M', option2: 'Slate', inventory_quantity: 8, price: 79 },
        { title: 'L / Slate', option1: 'L', option2: 'Slate', inventory_quantity: 3, price: 79 }
      ]
    },
    {
      title: 'Coastal Zip Fleece', type: 'Hoodies', vendor: 'Honeycomb Supply',
      price: 64, compare_at_price: null, total_inventory: 0, status: 'active', tags: ['fleece'],
      variants: [
        { title: 'S / Sea', option1: 'S', option2: 'Sea', inventory_quantity: 0, price: 64 },
        { title: 'M / Sea', option1: 'M', option2: 'Sea', inventory_quantity: 0, price: 64 }
      ]
    },
    {
      title: 'Trailhead Travel Set', type: 'Travel Set', vendor: 'Northwind Apparel',
      price: 129, compare_at_price: null, total_inventory: 42, status: 'active', tags: ['bestseller'],
      variants: [{ title: 'One-Size', option1: 'One-Size', option2: null, inventory_quantity: 42, price: 129 }]
    },
    {
      title: 'Summit Insulated Flask', type: 'Accessories', vendor: 'Northwind Apparel',
      price: 24, compare_at_price: null, total_inventory: 5, status: 'draft', tags: [],
      variants: [{ title: 'One-Size', option1: 'One-Size', option2: null, inventory_quantity: 5, price: 24 }]
    },
    {
      title: 'Aurora Desk Lamp', type: 'Lighting', vendor: 'Acme Widgets Co.',
      price: 149, compare_at_price: 189, total_inventory: 3, status: 'active', tags: ['new-in'],
      variants: [{ title: 'One-Size', option1: 'One-Size', option2: null, inventory_quantity: 3, price: 149 }]
    },
    {
      title: 'Harbour Tee', type: 'T-Shirts', vendor: 'Honeycomb Supply',
      price: 19, compare_at_price: null, total_inventory: 120, status: 'active', tags: [],
      variants: [
        { title: 'S', option1: 'S', option2: null, inventory_quantity: 40, price: 19 },
        { title: 'M', option1: 'M', option2: null, inventory_quantity: 50, price: 19 },
        { title: 'L', option1: 'L', option2: null, inventory_quantity: 30, price: 19 }
      ]
    }
  ];

  var PRESETS = {
    sizes: "{% for variant in product.variants %}\n  {% if variant.inventory_quantity > 0 %}\n    {% assign size = variant.option1 | downcase %}\n    {% capture size_tag %}size-{{ size }}{% endcapture %}\n    {% add_tag size_tag %}\n    {% if variant.option2 != blank %}\n      {% assign color = variant.option2 | downcase %}\n      {% capture color_tag %}color-{{ color }}{% endcapture %}\n      {% add_tag color_tag %}\n    {% endif %}\n  {% endif %}\n{% endfor %}",
    stock: "{% if product.total_inventory == 0 %}\n  {% add_tag 'sold-out' %}\n{% elsif product.total_inventory < 6 %}\n  {% add_tag 'low-stock' %}\n{% elsif product.total_inventory >= 100 %}\n  {% add_tag 'deep-stock' %}\n{% else %}\n  {% add_tag 'in-stock' %}\n{% endif %}\n{% unless product.status == 'active' %}\n  {% add_tag 'not-published' %}\n{% endunless %}",
    sale: "{% if product.compare_at_price > product.price %}\n  {% assign original = product.compare_at_price %}\n  {% assign saving = original | minus: product.price %}\n  {% assign percent = saving | times: 100 | divided_by: original | round %}\n  {% capture sale_tag %}sale-{{ percent }}-off{% endcapture %}\n  {% add_tag 'sale' %}\n  {% add_tag sale_tag %}\n  {% if percent >= 20 %}\n    {% add_tag 'big-discount' %}\n  {% endif %}\n{% endif %}",
    bands: "{% assign band = 'premium' %}\n{% if product.price < 30 %}\n  {% assign band = 'budget' %}\n{% elsif product.price < 100 %}\n  {% assign band = 'mid' %}\n{% endif %}\n{% capture band_tag %}price-{{ band }}{% endcapture %}\n{% add_tag band_tag %}\n{% if band == 'premium' and product.compare_at_price != blank %}\n  {% add_tag 'premium-on-sale' %}\n{% endif %}",
    brand: "{% assign vendor = product.vendor | downcase %}\n{% capture brand_tag %}brand-{{ vendor }}{% endcapture %}\n{% add_tag brand_tag %}\n{% if vendor contains 'northwind' and product.status == 'active' %}\n  {% add_tag 'house-brand' %}\n{% endif %}\n{% if vendor contains 'acme' or vendor contains 'honeycomb' %}\n  {% add_tag 'partner-brand' %}\n{% endif %}",
    typecase: "{% case product.type %}\n  {% when 'Hoodies' or 'T-Shirts' %}\n    {% add_tag 'apparel' %}\n  {% when 'Lighting' %}\n    {% add_tag 'homeware' %}\n  {% else %}\n    {% assign type = product.type | downcase %}\n    {% capture type_tag %}type-{{ type }}{% endcapture %}\n    {% add_tag type_tag %}\n{% endcase %}",
    retire: "{% if product.compare_at_price > product.price %}\n  {% add_tag 'sale' %}\n  {% if product.tags contains 'new-in' %}\n    {% remove_tag 'new-in' %}\n    {% add_tag 'was-new' %}\n  {% endif %}\n{% endif %}",
    variants: "{% assign count = product.variants | size %}\n{% capture count_tag %}variants-{{ count }}{% endcapture %}\n{% add_tag count_tag %}\n{% if count > 1 %}\n  {% add_tag 'multi-variant' %}\n{% else %}\n  {% add_tag 'single-variant' %}\n{% endif %}",
    keywords: "{% assign title = product.title | downcase %}\n{% if title contains 'zip' %}\n  {% add_tag 'zip-up' %}\n{% endif %}\n{% if title contains 'summit' or title contains 'trailhead' %}\n  {% add_tag 'peak-series' %}\n{% endif %}\n{% if product.type == 'Accessories' and product.price < 30 %}\n  {% add_tag 'gift-idea' %}\n{% endif %}"
  };

  // ---- shared tag vocabulary (port of app/lib/liquid.ts) -------------------
  var BLOCK_OPENERS = ['if', 'unless', 'for', 'case', 'capture', 'tablerow', 'raw', 'comment'];
  var BLOCK_CLOSERS = {
    endif: 'if', endunless: 'unless', endfor: 'for', endcase: 'case',
    endcapture: 'capture', endtablerow: 'tablerow', endraw: 'raw', endcomment: 'comment'
  };
  var MIDDLE = ['else', 'elsif', 'when', 'break', 'continue'];
  var LEAF_TAGS = ['assign', 'add_tag', 'remove_tag', 'increment', 'decrement', 'include', 'render', 'echo', 'liquid', 'cycle', 'section', 'layout'];
  var KNOWN_TAGS = {};
  BLOCK_OPENERS.concat(Object.keys(BLOCK_CLOSERS), MIDDLE, LEAF_TAGS).forEach(function (t) { KNOWN_TAGS[t] = true; });

  var BLOCK_RE = /\{%-?[\s\S]*?-?%\}|\{\{-?[\s\S]*?-?\}\}|\{#[\s\S]*?#\}/g;

  function lineOf(src, idx) {
    var n = 1;
    for (var i = 0; i < idx && i < src.length; i++) if (src[i] === '\n') n++;
    return n;
  }
  function innerOf(block) {
    return block.replace(/^\{[%{]-?/, '').replace(/-?[%}]\}$/, '').trim();
  }

  // ---- linting -------------------------------------------------------------
  function lintLiquid(src) {
    var issues = [];
    if (src.trim() === '') return issues;

    var masked = src.replace(BLOCK_RE, function (m) { return new Array(m.length + 1).join(' '); });
    var stray = /\{%|\{\{|\{#|%\}|\}\}|#\}/g;
    var sm;
    while ((sm = stray.exec(masked))) {
      issues.push({ severity: 'error', line: lineOf(src, sm.index), message: 'Unbalanced "' + sm[0] + '" - every {% %} and {{ }} must be opened and closed.' });
    }

    var stack = [];
    var hasTagOp = false;
    var m;
    BLOCK_RE.lastIndex = 0;
    while ((m = BLOCK_RE.exec(src))) {
      var block = m[0];
      if (block.indexOf('{%') !== 0) continue;
      var line = lineOf(src, m.index);
      var inner = innerOf(block);
      var name = inner.split(/\s+/)[0] || '';
      var rest = inner.slice(name.length).trim();

      if (BLOCK_OPENERS.indexOf(name) !== -1) {
        stack.push({ name: name, line: line });
      } else if (BLOCK_CLOSERS[name]) {
        var expected = BLOCK_CLOSERS[name];
        var top = stack[stack.length - 1];
        if (!top) issues.push({ severity: 'error', line: line, message: '"{% ' + name + ' %}" has no matching "{% ' + expected + ' %}".' });
        else if (top.name !== expected) issues.push({ severity: 'error', line: line, message: '"{% ' + name + ' %}" doesn\'t match "{% ' + top.name + ' %}" opened on line ' + top.line + '.' });
        else stack.pop();
      } else if (name === 'add_tag' || name === 'remove_tag') {
        hasTagOp = true;
        if (rest === '') issues.push({ severity: 'warning', line: line, message: '"{% ' + name + ' %}" needs a tag name, e.g. {% ' + name + " 'sale' %}." });
      } else if (name === 'assign') {
        if (rest.indexOf('=') === -1) issues.push({ severity: 'warning', line: line, message: '"{% assign %}" needs a name and value, e.g. {% assign x = product.title %}.' });
      } else if (!KNOWN_TAGS[name]) {
        issues.push({ severity: 'warning', line: line, message: 'Unknown tag "{% ' + name + ' %}" - check the spelling.' });
      }
    }
    for (var s = 0; s < stack.length; s++) {
      issues.push({ severity: 'error', line: stack[s].line, message: '"{% ' + stack[s].name + ' %}" is never closed - add "{% end' + stack[s].name + ' %}".' });
    }
    var hasError = issues.some(function (i) { return i.severity === 'error'; });
    if (!hasTagOp && !hasError) {
      issues.push({ severity: 'warning', line: 1, message: "This rule never calls {% add_tag %}, so it won't tag anything." });
    }
    return issues.sort(function (a, b) { return a.line - b.line; });
  }

  // ---- evaluation ----------------------------------------------------------
  var EMPTY = { empty: true };

  function tokenize(src) {
    var toks = [];
    var last = 0;
    var m;
    BLOCK_RE.lastIndex = 0;
    while ((m = BLOCK_RE.exec(src))) {
      if (m.index > last) toks.push({ kind: 'text', body: src.slice(last, m.index) });
      var block = m[0];
      if (block.indexOf('{%') === 0) toks.push({ kind: 'tag', body: innerOf(block) });
      else if (block.indexOf('{{') === 0) toks.push({ kind: 'output', body: innerOf(block) });
      last = m.index + block.length;
    }
    if (last < src.length) toks.push({ kind: 'text', body: src.slice(last) });
    return toks;
  }

  function parse(toks) {
    var pos = 0;

    function nameAt() {
      var tk = toks[pos];
      return tk && tk.kind === 'tag' ? (tk.body.split(/\s+/)[0] || '') : null;
    }
    function eat(name) { if (nameAt() === name) pos++; }

    function nodes(stops) {
      var out = [];
      while (pos < toks.length) {
        var tk = toks[pos];
        if (tk.kind === 'text') { out.push({ t: 'text', value: tk.body }); pos++; continue; }
        if (tk.kind === 'output') { out.push({ t: 'output', expr: tk.body }); pos++; continue; }
        var name = tk.body.split(/\s+/)[0] || '';
        var arg = tk.body.slice(name.length).trim();
        if (stops.indexOf(name) !== -1) return out;
        pos++;

        if (name === 'add_tag' || name === 'remove_tag') {
          out.push({ t: 'add', remove: name === 'remove_tag', expr: arg });
        } else if (name === 'assign') {
          var eq = arg.indexOf('=');
          if (eq > 0) out.push({ t: 'assign', name: arg.slice(0, eq).trim(), expr: arg.slice(eq + 1).trim() });
        } else if (name === 'if') {
          var branches = [{ cond: arg, body: nodes(['elsif', 'else', 'endif']) }];
          while (nameAt() === 'elsif') {
            var c = toks[pos].body.slice(5).trim(); pos++;
            branches.push({ cond: c, body: nodes(['elsif', 'else', 'endif']) });
          }
          if (nameAt() === 'else') { pos++; branches.push({ cond: null, body: nodes(['endif']) }); }
          eat('endif');
          out.push({ t: 'if', branches: branches });
        } else if (name === 'unless') {
          var ubody = nodes(['else', 'endunless']);
          var uelse = null;
          if (nameAt() === 'else') { pos++; uelse = nodes(['endunless']); }
          eat('endunless');
          out.push({ t: 'unless', cond: arg, body: ubody, elseBody: uelse });
        } else if (name === 'for') {
          var coll = arg.replace(/^(\w+)\s+in\s+/, '');
          var vm = /^(\w+)\s+in\s+/.exec(arg);
          var varName = vm ? vm[1] : '';
          var reversed = /\breversed\b/.test(coll);
          coll = coll.replace(/\s+(limit|offset)\s*:\s*\S+/g, '').replace(/\s+reversed\b/g, '').trim();
          var fbody = nodes(['else', 'endfor']);
          var felse = null;
          if (nameAt() === 'else') { pos++; felse = nodes(['endfor']); }
          eat('endfor');
          if (varName) out.push({ t: 'for', varName: varName, collExpr: coll, reversed: reversed, body: fbody, elseBody: felse });
        } else if (name === 'case') {
          nodes(['when', 'else', 'endcase']);
          var whens = [];
          while (nameAt() === 'when') {
            var vals = toks[pos].body.slice(4).trim().split(/\s+or\s+|,/).map(function (s) { return s.trim(); }).filter(Boolean);
            pos++;
            whens.push({ vals: vals, body: nodes(['when', 'else', 'endcase']) });
          }
          var celse = null;
          if (nameAt() === 'else') { pos++; celse = nodes(['endcase']); }
          eat('endcase');
          out.push({ t: 'case', subject: arg, whens: whens, elseBody: celse });
        } else if (name === 'capture') {
          var cbody = nodes(['endcapture']);
          eat('endcapture');
          if (arg) out.push({ t: 'capture', name: arg, body: cbody });
        } else if (name === 'tablerow') {
          out.push({ t: 'block', body: nodes(['endtablerow']) });
          eat('endtablerow');
        } else if (name === 'comment' || name === 'raw') {
          nodes([name === 'comment' ? 'endcomment' : 'endraw']);
          eat(name === 'comment' ? 'endcomment' : 'endraw');
        }
      }
      return out;
    }

    return nodes([]);
  }

  function isEmptyVal(v) {
    return v == null || v === EMPTY || (typeof v === 'string' && v === '') || (Array.isArray(v) && v.length === 0);
  }
  function truthy(v) { return v !== false && v != null; }
  function numOf(v) {
    if (typeof v === 'number') return isFinite(v) ? v : null;
    if (typeof v === 'string' && /^-?\d+(\.\d+)?$/.test(v.trim())) return Number(v.trim());
    return null;
  }
  function toStr(v) {
    if (v == null || v === EMPTY) return '';
    if (Array.isArray(v)) return v.join(', ');
    return String(v);
  }

  function member(cur, key) {
    if (cur == null) return undefined;
    if (key === 'size' || key === 'count') return Array.isArray(cur) ? cur.length : String(cur).length;
    if (key === 'first') return Array.isArray(cur) ? cur[0] : undefined;
    if (key === 'last') return Array.isArray(cur) ? cur[cur.length - 1] : undefined;
    return typeof cur === 'object' ? cur[key] : undefined;
  }

  function resolvePath(path, ctx) {
    var segs = path.split('.');
    if (!(segs[0] in ctx.scope)) return undefined;
    var cur = ctx.scope[segs[0]];
    for (var i = 1; i < segs.length; i++) cur = member(cur, segs[i]);
    return cur;
  }

  function splitTop(s, delim) {
    var out = [];
    var buf = '', quote = '';
    for (var i = 0; i < s.length; i++) {
      var c = s[i];
      if (quote) { buf += c; if (c === quote) quote = ''; continue; }
      if (c === "'" || c === '"') { quote = c; buf += c; continue; }
      if (c === delim) { out.push(buf); buf = ''; continue; }
      buf += c;
    }
    out.push(buf);
    return out;
  }

  function applyFilter(v, name, args) {
    var a0 = args[0];
    switch (name) {
      case 'downcase': return toStr(v).toLowerCase();
      case 'upcase': return toStr(v).toUpperCase();
      case 'capitalize': { var s = toStr(v); return s.charAt(0).toUpperCase() + s.slice(1); }
      case 'strip': return toStr(v).trim();
      case 'append': return toStr(v) + toStr(a0);
      case 'prepend': return toStr(a0) + toStr(v);
      case 'default': return isEmptyVal(v) ? a0 : v;
      case 'size': return Array.isArray(v) ? v.length : toStr(v).length;
      case 'first': return Array.isArray(v) ? v[0] : v;
      case 'last': return Array.isArray(v) ? v[v.length - 1] : v;
      case 'join': return Array.isArray(v) ? v.join(toStr(a0) || ' ') : toStr(v);
      case 'plus': return (numOf(v) || 0) + (numOf(a0) || 0);
      case 'minus': return (numOf(v) || 0) - (numOf(a0) || 0);
      case 'times': return (numOf(v) || 0) * (numOf(a0) || 0);
      case 'divided_by': { var d = numOf(a0) || 0; return d === 0 ? 0 : (numOf(v) || 0) / d; }
      case 'round': return Math.round(numOf(v) || 0);
      case 'abs': return Math.abs(numOf(v) || 0);
      default: return v;
    }
  }

  function evalAtom(raw, ctx) {
    var s = raw.trim();
    if (s === '') return undefined;
    if ((s[0] === "'" && s.slice(-1) === "'") || (s[0] === '"' && s.slice(-1) === '"')) return s.slice(1, -1);
    if (/^-?\d+(\.\d+)?$/.test(s)) return Number(s);
    if (s === 'true') return true;
    if (s === 'false') return false;
    if (s === 'nil' || s === 'null') return null;
    if (s === 'empty' || s === 'blank') return EMPTY;
    return resolvePath(s, ctx);
  }

  function evalExpr(expr, ctx) {
    var parts = splitTop(expr, '|').map(function (p) { return p.trim(); });
    var v = evalAtom(parts[0], ctx);
    for (var i = 1; i < parts.length; i++) {
      var seg = parts[i];
      var colon = seg.indexOf(':');
      var fname = (colon === -1 ? seg : seg.slice(0, colon)).trim();
      var args = colon === -1 ? [] : splitTop(seg.slice(colon + 1), ',').map(function (a) { return evalAtom(a, ctx); });
      v = applyFilter(v, fname, args);
    }
    return v;
  }

  function looseEq(a, b) {
    if (a === EMPTY) return isEmptyVal(b);
    if (b === EMPTY) return isEmptyVal(a);
    var an = numOf(a), bn = numOf(b);
    if (an != null && bn != null) return an === bn;
    return toStr(a) === toStr(b);
  }

  function evalTerm(term, ctx) {
    var t = term.trim();
    var m = /^(.+?)\s*(==|!=|>=|<=|>|<|\bcontains\b)\s*(.+)$/.exec(t);
    if (!m) return truthy(evalExpr(t, ctx));
    var left = evalExpr(m[1], ctx);
    var op = m[2];
    var right = evalExpr(m[3], ctx);
    switch (op) {
      case '==': return looseEq(left, right);
      case '!=': return !looseEq(left, right);
      case 'contains': return Array.isArray(left) ? left.map(String).indexOf(toStr(right)) !== -1 : toStr(left).indexOf(toStr(right)) !== -1;
      default: {
        var an = numOf(left), bn = numOf(right);
        var cmp = an != null && bn != null ? an - bn : toStr(left).localeCompare(toStr(right));
        return op === '>' ? cmp > 0 : op === '<' ? cmp < 0 : op === '>=' ? cmp >= 0 : cmp <= 0;
      }
    }
  }

  function evalCond(cond, ctx) {
    var tokens = cond.split(/\s+(and|or)\s+/);
    var result = evalTerm(tokens[0], ctx);
    for (var i = 1; i < tokens.length; i += 2) {
      var val = evalTerm(tokens[i + 1], ctx);
      result = tokens[i] === 'and' ? (result && val) : (result || val);
    }
    return result;
  }

  function toArray(v) {
    if (Array.isArray(v)) return v;
    if (v == null) return null;
    return [];
  }

  function exec(list, ctx, buf) {
    for (var n = 0; n < list.length; n++) {
      var node = list[n];
      switch (node.t) {
        case 'text':
          if (buf) buf.s += node.value;
          break;
        case 'output':
          if (buf) buf.s += toStr(evalExpr(node.expr, ctx));
          break;
        case 'add': {
          var tag = toStr(evalExpr(node.expr, ctx)).trim();
          if (!tag) break;
          if (node.remove) { if (ctx.removed.indexOf(tag) === -1) ctx.removed.push(tag); }
          else if (ctx.added.indexOf(tag) === -1) ctx.added.push(tag);
          break;
        }
        case 'assign':
          ctx.scope[node.name] = evalExpr(node.expr, ctx);
          break;
        case 'capture': {
          var inner = { s: '' };
          exec(node.body, ctx, inner);
          ctx.scope[node.name] = inner.s;
          break;
        }
        case 'if': {
          for (var b = 0; b < node.branches.length; b++) {
            var br = node.branches[b];
            if (br.cond == null || evalCond(br.cond, ctx)) { exec(br.body, ctx, buf); break; }
          }
          break;
        }
        case 'unless': {
          if (!evalCond(node.cond, ctx)) exec(node.body, ctx, buf);
          else if (node.elseBody) exec(node.elseBody, ctx, buf);
          break;
        }
        case 'for': {
          var arr = toArray(evalExpr(node.collExpr, ctx));
          var items = arr && node.reversed ? arr.slice().reverse() : arr;
          if (items && items.length > 0) {
            for (var i = 0; i < items.length; i++) {
              ctx.scope[node.varName] = items[i];
              ctx.scope.forloop = { index: i + 1, index0: i, first: i === 0, last: i === items.length - 1, length: items.length };
              exec(node.body, ctx, buf);
            }
            delete ctx.scope[node.varName];
            delete ctx.scope.forloop;
          } else if (node.elseBody) {
            exec(node.elseBody, ctx, buf);
          }
          break;
        }
        case 'case': {
          var subj = evalExpr(node.subject, ctx);
          var matched = false;
          for (var w = 0; w < node.whens.length; w++) {
            var hit = node.whens[w].vals.some(function (val) { return looseEq(evalAtom(val, ctx), subj); });
            if (hit) { exec(node.whens[w].body, ctx, buf); matched = true; break; }
          }
          if (!matched && node.elseBody) exec(node.elseBody, ctx, buf);
          break;
        }
        case 'block':
          exec(node.body, ctx, buf);
          break;
      }
    }
  }

  function evaluateLiquid(source, product) {
    var ctx = { scope: { product: product }, added: [], removed: [] };
    try {
      exec(parse(tokenize(source)), ctx);
    } catch (e) {
      return { tags: [], removed: [] };
    }
    var tags = ctx.added.filter(function (t) { return ctx.removed.indexOf(t) === -1; });
    return { tags: tags, removed: ctx.removed };
  }

  // ---- syntax highlighting (port of liquidHighlight.ts) --------------------
  var COLORS = {
    delim: '#8b7dff', tag: '#ff9cc8', string: '#b8e56a', number: '#f0a367',
    op: '#7fd9e8', filter: '#ffcb6b', prop: '#82aaff', comment: '#6a6580', plain: '#e7e3f5'
  };
  var HL_KEYWORDS = {};
  ['if', 'elsif', 'else', 'endif', 'unless', 'endunless', 'case', 'when', 'endcase',
    'for', 'endfor', 'break', 'continue', 'cycle', 'tablerow', 'endtablerow',
    'assign', 'capture', 'endcapture', 'increment', 'decrement',
    'include', 'render', 'comment', 'endcomment', 'raw', 'endraw',
    'liquid', 'echo', 'section', 'add_tag', 'remove_tag'].forEach(function (k) { HL_KEYWORDS[k] = true; });
  var HL_OPERATORS = {};
  ['and', 'or', 'contains', 'in', 'with', 'as', 'by', 'limit', 'offset', 'reversed'].forEach(function (k) { HL_OPERATORS[k] = true; });
  var HL_CONSTS = {};
  ['true', 'false', 'nil', 'null', 'empty', 'blank'].forEach(function (k) { HL_CONSTS[k] = true; });

  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function span(color, text, italic) {
    var style = italic ? 'color:' + color + ';font-style:italic' : 'color:' + color;
    return '<span style="' + style + '">' + esc(text) + '</span>';
  }

  function highlightInner(inner, isTag) {
    var out = '';
    var tok = /(\s+)|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*")|(\d+\.?\d*)|([A-Za-z_][A-Za-z0-9_]*)|([|.:=<>!?]+|[(),[\]])|(.)/g;
    var firstWord = isTag;
    var prev = '';
    var m;
    while ((m = tok.exec(inner))) {
      if (m[1]) { out += esc(m[1]); continue; }
      if (m[2]) { out += span(COLORS.string, m[2]); prev = 'str'; continue; }
      if (m[3]) { out += span(COLORS.number, m[3]); prev = 'num'; continue; }
      if (m[4]) {
        var w = m[4];
        var color;
        if (firstWord) color = COLORS.tag;
        else if (prev === '|') color = COLORS.filter;
        else if (prev === '.') color = COLORS.prop;
        else if (HL_KEYWORDS[w]) color = COLORS.tag;
        else if (HL_OPERATORS[w]) color = COLORS.op;
        else if (HL_CONSTS[w]) color = COLORS.number;
        else color = COLORS.plain;
        out += span(color, w);
        firstWord = false;
        prev = w;
        continue;
      }
      if (m[5]) { out += span(COLORS.op, m[5]); prev = m[5]; continue; }
      out += esc(m[6]); prev = m[6];
    }
    return out;
  }

  function highlightBlock(block) {
    var isTag = block.indexOf('{%') === 0;
    var open = (block.match(/^\{[%{]-?/) || [''])[0];
    var close = (block.match(/-?[%}]\}$/) || [''])[0];
    var inner = block.slice(open.length, block.length - close.length);
    return span(COLORS.delim, open) + highlightInner(inner, isTag) + span(COLORS.delim, close);
  }

  function highlightLiquid(src) {
    var out = '';
    var last = 0;
    var m;
    BLOCK_RE.lastIndex = 0;
    while ((m = BLOCK_RE.exec(src))) {
      if (m.index > last) out += span(COLORS.plain, src.slice(last, m.index));
      var block = m[0];
      out += block.indexOf('{#') === 0 ? span(COLORS.comment, block, true) : highlightBlock(block);
      last = m.index + block.length;
    }
    if (last < src.length) out += span(COLORS.plain, src.slice(last));
    return out;
  }

  // ---- editor wiring -------------------------------------------------------
  var ta = root.querySelector('[data-st-lq-ta]');
  var hl = root.querySelector('[data-st-lq-hl]');
  var gutter = root.querySelector('[data-st-lq-gutter]');
  var lintEl = root.querySelector('[data-st-lq-lint]');
  var prodWrap = root.querySelector('[data-st-lq-products]');
  var summary = root.querySelector('[data-st-lq-summary]');

  function money(n) { return '$' + n; }

  function renderEditor() {
    var src = ta.value;
    hl.innerHTML = highlightLiquid(src) + '\n';
    var lines = src.split('\n').length;
    var nums = '';
    for (var i = 1; i <= lines; i++) nums += i + '\n';
    gutter.textContent = nums;
    syncScroll();
  }

  function syncScroll() {
    hl.scrollTop = ta.scrollTop;
    hl.scrollLeft = ta.scrollLeft;
    gutter.scrollTop = ta.scrollTop;
  }

  function renderLint(issues) {
    var err = issues.filter(function (i) { return i.severity === 'error'; })[0];
    var warn = issues.filter(function (i) { return i.severity === 'warning'; })[0];
    if (err) {
      lintEl.className = 'st-lq__lint st-lq__lint--error';
      lintEl.textContent = 'Line ' + err.line + ': ' + err.message;
    } else if (warn) {
      lintEl.className = 'st-lq__lint st-lq__lint--warn';
      lintEl.textContent = 'Line ' + warn.line + ': ' + warn.message;
    } else {
      lintEl.className = 'st-lq__lint st-lq__lint--ok';
      lintEl.textContent = 'Looks good - no problems found.';
    }
    return !err;
  }

  function renderPreview(runnable) {
    prodWrap.innerHTML = '';
    var touched = 0;
    var removedAny = false;

    PRODUCTS.forEach(function (p) {
      var result = runnable ? evaluateLiquid(ta.value, p) : { tags: [], removed: [] };
      var added = result.tags.filter(function (t) { return p.tags.indexOf(t) === -1; });
      var removed = result.removed.filter(function (t) { return p.tags.indexOf(t) !== -1; });
      var hit = added.length > 0 || removed.length > 0;
      if (hit) touched++;
      if (removed.length) removedAny = true;

      var card = document.createElement('div');
      card.className = 'st-demo__product ' + (hit ? 'is-match' : 'is-miss');

      var name = document.createElement('div');
      name.className = 'st-demo__pname';
      name.textContent = p.title;

      var meta = document.createElement('div');
      meta.className = 'st-demo__pmeta';
      meta.textContent = p.type + ' · ' + p.vendor + ' · ' + money(p.price)
        + (p.compare_at_price ? ' (was ' + money(p.compare_at_price) + ')' : '')
        + ' · ' + p.total_inventory + ' in stock · ' + p.variants.length
        + (p.variants.length === 1 ? ' variant' : ' variants');

      var tags = document.createElement('div');
      tags.className = 'st-demo__ptags';
      p.tags.forEach(function (t) {
        var el = document.createElement('span');
        el.className = 'st-demo__ptag' + (removed.indexOf(t) !== -1 ? ' st-lq__ptag--rm' : '');
        el.textContent = t;
        tags.appendChild(el);
      });
      added.forEach(function (t) {
        var el = document.createElement('span');
        el.className = 'st-demo__ptag st-demo__ptag--new';
        el.textContent = '+ ' + t;
        tags.appendChild(el);
      });

      card.appendChild(name); card.appendChild(meta); card.appendChild(tags);
      prodWrap.appendChild(card);
    });

    if (!runnable) {
      summary.textContent = 'Fix the Liquid to see the live preview.';
    } else {
      summary.innerHTML = '<b>' + touched + ' of ' + PRODUCTS.length + '</b> demo products change with this rule.'
        + (removedAny ? ' Struck-through tags would be removed.' : '');
    }
    syncPresets();
  }

  function update() {
    renderEditor();
    var ok = renderLint(lintLiquid(ta.value));
    renderPreview(ok);
  }

  function syncPresets() {
    root.querySelectorAll('[data-st-lq-preset]').forEach(function (btn) {
      var code = PRESETS[btn.dataset.stLqPreset];
      btn.classList.toggle('is-active', !!code && ta.value === code);
    });
  }

  ta.addEventListener('input', update);
  ta.addEventListener('scroll', syncScroll);
  ta.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      e.preventDefault();
      var start = ta.selectionStart, end = ta.selectionEnd;
      ta.value = ta.value.slice(0, start) + '  ' + ta.value.slice(end);
      ta.selectionStart = ta.selectionEnd = start + 2;
      update();
    }
  });

  root.querySelectorAll('[data-st-lq-preset]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = PRESETS[btn.dataset.stLqPreset];
      if (!code) return;
      ta.value = code;
      update();
    });
  });

  ta.value = PRESETS.sizes;
  update();
})();
